<template>
  <modal
    :open="isOpen"
    :title="modalTitle"
    @save="create"
    @cancel="cancel"
  >
    <field
      :required="true"
      :errors="errors"
      model="workflow"
      name="name"
      v-model="item.name"
      placeholder="Form Name"
    />
    <field
      :required="true"
      name="scope"
      type="radio"
      model="workflow"
      v-model="workflowScope"
      :collection="workflowScopes"
    />
    <field
      v-if="workflowScope == 'project'"
      v-can="'projects.list'"
      :required="true"
      :errors="errors"
      model="workflow"
      name="project"
      v-model="item.project_id"
      type="select"
      :collection="projects"
      :params="{'no_i18n': true}"
    />
    <field
      :required="false"
      :errors="errors"
      model="lead_mask"
      v-if="isRoot"
      name="organization"
      v-model="item.organization"
      type="select"
      :params="{ no_i18n: true }"
      :collection="organizations"
    />
  </modal>
</template>
<script>
import {EventBus} from '@/EventBus'
import Field from '@helpers/DataInput/Field'
import ProjectApi from '@/api/Project'
import OrganizationApi from "@/api/Organization"
import Permission from "@/classes/Permission"
import WorkflowApi from '@/api/Workflow'
import Modal from '@/components/helpers/Layout/NewModal'

export default {
  components: {
    Field,
    Modal
  },
  data(){
    return{
      isOpen: false,
      item: {},
      errors: [],
      projects: [],
      organizations: [],
      workflowScope: 'organization',
      workflowScopes: [
          { name: 'organization', value: 'organization' },
          { name: 'project', value: 'project' }
        ]
    }
  },
  computed: {
    modalTitle () {
      return this.$t('ui.modals.workflow.create.title')
    },
    isRoot: {
      get () {
        return this.$store.getters.getCurrentUserIsRoot
      }
    }
  },
  mounted(){
    EventBus.$off('action')
    EventBus.$on('action',this.handleAction)
    this.retrieve_projects()
    this.retrieve_organizations()
    EventBus.$on('open', open => {
      this.isOpen = true
    });
  },
  methods: {
    create(){
      let api = new WorkflowApi()
      let item = this.initItem(this.item)

      api.post(item).then((item) => {
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.workflow.message.create',
          'type': 'success'
        })
        this.$router.push({name: 'workflow_edit', params: {id: item.id}})
      }).catch((e) => {
        this.errors = e.response.data.errors
      })
    },
    initItem(item){
      item.execute_on = {}
      item.configuration = {}
      return item
    },
    handleAction(action){
      this.isOpen = action == 'workflow.add_popup'
    },
    retrieve_projects(){
      let api = new ProjectApi()
      api.all_for_association('name', {sort_by: 'name', sort_order: 'DESC'}).then((items) => {
        this.projects = items
      }).catch(function(error) {
        console.log(error)
      })
    },
    retrieve_organizations() {
      const permission = Permission.loadPermissions();

      if (Permission.can(permission, "organizations.list")) {
        let api = new OrganizationApi();
        api
          .all_for_association()
          .then(items => {
            this.organizations = items;
          })
          .catch(function(error) {});
      }
    },
    cancel(){
      this.isOpen = false
    },
    open(){
      this.isOpen = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// WorkflowCreate.vue?7b0e8389